(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('linkedText', ["routeHelper", function (routeHelper) {
        var beforePatterns = [
            '#{',
            ': ',
            ', ',
            '[{',
            ' {'
        ];
        var afterPatterns = [
            ': ',
            ', ',
            '},',
            '}]',
            '})',
            '}\'',
            '} '
        ];
        var beforePatternsForSingle = ['"}'];
        var afterPatternsForSingle = ['#{'];
        function findEnd(text) {
            var count = 1;
            var pos = 1;
            var inQuotes = false;
            var slashesCount = 0;
            while (count > 0) {
                pos++;
                if (text[pos] === '\\') {
                    slashesCount++;
                } else {
                    slashesCount = 0;
                }
                if (text[pos] === '"' && slashesCount % 2 === 0) {
                    inQuotes = !inQuotes;
                }
                if (!inQuotes) {
                    if (text[pos] == '}') {
                        count--;
                    } else if (text[pos] == '{') {
                        count++;
                    }
                }
                if (pos == text.length) {
                    return -1;
                }
            }
            return pos;
        }
        function replaceWrongQuote(text, type) {
            if (!text.length)
                return text;
            var wrongPositions = [];
            var goodText = '';
            if (type === 'single') {
                for (var i = 0; i < text.length; i++) {
                    if (text[i] === '\'') {
                        if (!checkingNearBy(text, i, type)) {
                            wrongPositions.push(i);
                        }
                    } else if (text[i] === '\\') {
                        wrongPositions.push(i);
                    }
                }
            } else {
                for (var j = 0; j < text.length; j++) {
                    if (text[j] === '"') {
                        if (!checkingNearBy(text, j, type)) {
                            wrongPositions.push(j);
                        }
                    } else if (text[j] === '\\') {
                        wrongPositions.push(j);
                    }
                }
            }
            if (wrongPositions.length) {
                var beforePosition = 0;
                _(wrongPositions).each(function (pos) {
                    goodText += text.slice(beforePosition, pos);
                    beforePosition = pos + 1;
                });
                goodText += text.slice(beforePosition);
                return goodText;
            }
            return text;
        }
        function checkingNearBy(text, pos, type) {
            if (pos - 2 >= 0) {
                if (!checkingBeforeStr(text, pos, type)) {
                    if (pos + 2 < text.length) {
                        if (checkingAfterStr(text, pos, type)) {
                            return true;
                        }
                    } else if (pos + 2 == text.length && text[pos + 1] === '}') {
                        return true;
                    }
                    return false;
                }
                return true;
            }
            if (pos + 2 < text.length) {
                if (checkingAfterStr(text, pos, type)) {
                    return true;
                }
            } else if (pos + 2 == text.length && text[pos + 1] === '}') {
                return true;
            }
            return false;
        }
        function checkingBeforeStr(text, pos, type) {
            var beforeStr = text.slice(pos - 2, pos);
            if (type === 'single') {
                return _(beforePatternsForSingle).findIndex(function (pattern) {
                    return pattern === beforeStr;
                }) !== -1;
            }
            return _(beforePatterns).findIndex(function (pattern) {
                return pattern === beforeStr;
            }) !== -1;
        }
        function checkingAfterStr(text, pos, type) {
            var afterStr;
            if (pos + 2 == text.length) {
                afterStr = text.slice(pos + 1, 0) + ' ';
            }
            afterStr = text.slice(pos + 1, pos + 3);
            if (type === 'single') {
                return _(afterPatternsForSingle).findIndex(function (pattern) {
                    return pattern === afterStr;
                }) !== -1;
            }
            return _(afterPatterns).findIndex(function (pattern) {
                return pattern === afterStr;
            }) !== -1;
        }
        var linkedText = {
            toSimpleParts: function (text) {
                //This function is including a potential issue
                if (_(text).isNull() || _(text).isUndefined()) {
                    text = '';
                }
                text = '' + text;
                var parts = [];
                var compareTxt = '';
                while (text.length) {
                    compareTxt = text;
                    var index = text.indexOf('#{');
                    if (index === -1) {
                        parts.push({
                            display: 'text',
                            text: text
                        });
                        text = '';
                    } else if (index > 0) {
                        parts.push({
                            display: 'text',
                            text: text.slice(0, index)
                        });
                        text = text.slice(index);
                    } else {
                        var end = findEnd(text);
                        var parsingData = text.slice(1, end + 1);
                        if (parsingData.indexOf('{\'') === 0) {
                            //There bug if data contains single quote
                            parsingData = parsingData.replace(/'/g, '"');
                        }
                        text = text.slice(end + 1);
                        if (parsingData) {
                            try {
                                parts.push(JSON.parse(parsingData));
                            } catch (err) {
                                // console.log('Error on toSimpleParts function!', err);
                                text = replaceWrongQuote(compareTxt, 'single');
                                text = replaceWrongQuote(text);
                            }
                        } else {
                            text = replaceWrongQuote(text);
                        }
                    }
                    if (compareTxt === text) {
                        break;
                    }
                }
                return parts;
            },
            toParts: function (text) {
                var parts = linkedText.toSimpleParts(text);
                return _(parts).map(function (data) {
                    var part = {
                        data: data,
                        display: data.display || data.type && 'link' || 'text',
                        'class': data['class']
                    };
                    if (part.display === 'link') {
                        part.data.path = data.path ? data.path : routeHelper.getHref(part.data.type, part.data, part.data.qs);
                    }
                    return part;
                });
            },
            toText: function (text) {
                var parts = this.toParts(text);
                return _(parts).reduce(function (memo, part) {
                    var partText = part.data.text;
                    if (!_(part.data.asText).isUndefined()) {
                        partText = part.data.asText;
                    }
                    if (part.display == 'inline-list') {
                        partText = _(part.data.data).map(function (el) {
                            return linkedText.toText(el);
                        }).join('\n');
                    }
                    partText = partText || '';
                    if (partText.indexOf('#{') === 0) {
                        memo.push(linkedText.toText(partText));
                        return memo;
                    }
                    memo.push(partText);
                    return memo;
                }, []).join(' ');
            }
        };
        return linkedText;
    }]);
}());